import { thunk, Action, Thunk, action, Computed, computed } from 'easy-peasy'
import { Token } from '../../atoms'
import { Network } from '../../services/token.service'
import { initTokensList, loadTokenBalances } from './helper'

export interface TokensModel {
    tokens: Record<string, Record<string, Token>> // {[networkId: string]: { [tokenId: string]: Token } }
    balance: Record<string, Record<string, string>> // {[networkId: string]: { [tokenId: string]: balance } }
    setTokens: Action<TokensModel, { network: Network; tokens: Record<string, Token> }>
    setBalance: Action<TokensModel, { network: Network; balances: Record<string, string> }>
    loadTokens: Thunk<TokensModel, { network: Network }>
    loadBalances: Thunk<TokensModel, { network: Network; walletAddress: string }>
    // eslint-disable-next-line no-unused-vars
    getTokensList: Computed<TokensModel, (network: string) => Token[]>
    // eslint-disable-next-line no-unused-vars
    getToken: Computed<TokensModel, (network: string, tokenAddress: string) => Token | null>
    // eslint-disable-next-line no-unused-vars
    // getTokenBySymbol: Computed<TokensModel, (network: string, symbol: string) => Token | null>
}

const tokensModel: TokensModel = {
    tokens: {},
    balance: {},

    getTokensList: computed((state) => (network) => state.tokens[network] ? Object.values(state.tokens[network]) : []),
    getToken: computed((state) => (network, tokenAddress) => state.tokens[network] ? state.tokens[network][tokenAddress] : null),
    // getTokenBySymbol: computed((state) => (network, symbol) => state.tokens[network] ? Object.values(state.tokens[network]).find((item) => item.symbol === symbol)! : null),

    setTokens: action((state, payload) => {
        if (!state.tokens[payload.network]) state.tokens = { ...state.tokens, [payload.network]: {} }
        state.tokens[payload.network] = { ...state.tokens[payload.network], ...payload.tokens }
    }),

    setBalance: action((state, payload) => {
        if (!state.balance[payload.network]) {
            state.balance = { ...state.balance, [payload.network]: {} }
        }

        state.balance[payload.network] = { ...state.balance[payload.network], ...payload.balances }
    }),

    loadTokens: thunk(async (actions, payload) => {
        const response = await initTokensList(payload.network)
        actions.setTokens({ network: payload.network, tokens: response })
    }),

    loadBalances: thunk(async (actions, payload, helpers) => {
        const tokens = helpers.getState().tokens[payload.network]
        if (!tokens) return
        const tokenAddresses = Object.keys(tokens)
        try {
            const response = await loadTokenBalances(payload.walletAddress, tokenAddresses, payload.network)
            const balances: Record<string, string> = {}

            response.map((balance) => {
                balances[balance.tokenAddress] = balance.balance
            })

            actions.setBalance({ network: payload.network, balances: balances })
        } catch (e) {}
    })
}

export default tokensModel
